import {cn} from '@/lib/utils'

/** Solo para listas cortas y cerradas: las entidades de cardinalidad N van en combobox buscable (R3). */
export function NativeSelect({className, ...props}: React.ComponentProps<'select'>) {
  return (
    <select
      data-slot="native-select"
      className={cn(
        'h-11 w-full rounded-lg border border-input bg-card px-3 text-sm text-foreground transition-colors outline-none hover:border-[color-mix(in_oklch,var(--input),var(--foreground)_18%)] focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-70 sm:h-9',
        className
      )}
      {...props}
    />
  )
}
